import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const Layout = ({ children }) => {
  return (
    <div className="flex bg-[#0A0A0A]" style={{ height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <div className="flex-1 flex flex-col" style={{ height: '100vh', overflow: 'hidden' }}>
        <TopBar />
        <main className="flex-1 p-6" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
